/**
 * Where a patient's insurance stands after an eligibility check. primary owns this vocabulary — the
 * insurance record stores the latest result, constrained to these values in the database.
 */
export var EligibilityCheckStatus;
(function (EligibilityCheckStatus) {
    EligibilityCheckStatus["Active"] = "ACTIVE";
    EligibilityCheckStatus["CannotProcess"] = "CANNOT_PROCESS";
    EligibilityCheckStatus["Completed"] = "COMPLETED";
    EligibilityCheckStatus["ContactOther"] = "CONTACT_OTHER";
    EligibilityCheckStatus["Error"] = "ERROR";
    EligibilityCheckStatus["Inactive"] = "INACTIVE";
    EligibilityCheckStatus["Initiated"] = "INITIATED";
    EligibilityCheckStatus["NonCovered"] = "NON_COVERED";
    EligibilityCheckStatus["Pending"] = "PENDING";
    EligibilityCheckStatus["PendingThirdPartyQueue"] = "PENDING_THIRD_PARTY_QUEUE";
    EligibilityCheckStatus["Unknown"] = "UNKNOWN";
})(EligibilityCheckStatus || (EligibilityCheckStatus = {}));
//# sourceMappingURL=eligibilityCheckStatus.js.map